import { Icon, Modal, Text } from 'components';

type Props = {
  open: boolean;
  message: string;
  onClose: () => void;
};

function Alert({
  open = false,
  message = '',
  onClose,
}: Props) {
  return (
    <Modal
      open={open}
      position="center"
      onClose={onClose}
      className="bg-white p-8 flex flex-col justify-between items-center mx-5"
    >
      <div onClick={onClose} className="absolute top-2 right-2 cursor-pointer">
        <Icon icon={'close'} />
      </div>
      <div className="flex flex-col">
        <Text className='text-sm'>{message}</Text>
      </div>
    </Modal>
  );
}

export default Alert;
